import { Expose } from "@nts/std/serialization";
import { FindOptions } from './find-options';

export class FindValuesOptions extends FindOptions {

    @Expose()
    outputProperties: string[];

    constructor(findOptions?: FindOptions, outputProperties: string[] = []) {
        super(findOptions);
        this.outputProperties = outputProperties;
    }
}
